import { detect } from "detect-browser"
import { appName } from "./domain"

const checkOS = os => {
    const supportedOsList = [
        "mac os",
        "windows 10",
        "windows 8.1",
        "android os",
        "ios"
    ]
    return supportedOsList.indexOf(os.slice().toLowerCase()) > -1 ? true : false
}

const checkBrowser = browserName => {
    const supportedBrowserList = ["chrome", "firefox", "safari", "edge"]
    return supportedBrowserList.indexOf(browserName.slice().toLowerCase()) > -1
        ? true
        : false
}

const checkVersion = (browser, version) => {
    let parsedVersion = parseInt(version.split(".")[0], 10)
    let parsedBrowser = browser.slice().toLowerCase()
    let result = null

    switch (parsedBrowser) {
        case "chrome":
            result = parsedVersion >= 45
            break
        case "firefox":
            result = parsedVersion >= 55
            break
        case "safari":
            result = parsedVersion >= 10
            break
        case "edge":
            result = parsedVersion >= 15
            break
        default:
            result = false
    }
    return result
}

export default () => {
    const browser = detect()

    if (!browser) {
        return `Unable to detect browser. ${appName()} support cannot be guaranteed on this device.`
    } else {
        const testResults = {
            os: [checkOS(browser.os), browser.os],
            browser: [checkBrowser(browser.name), browser.name],
            version: [
                checkVersion(browser.name, browser.version),
                browser.version
            ]
        }
        const comments = [
            testResults.os[0]
                ? null
                : `${appName()} support cannot be guaranteed on ` +
                  testResults.os[1],
            testResults.browser[0]
                ? null
                : `${appName()} is not supported on ` + testResults.browser[1],
            testResults.version[0]
                ? null
                : `${appName()} is not supported on version ` +
                  testResults.version[1] +
                  " of " +
                  testResults.browser[1]
        ]
        let comment = null

        if (comments[0]) {
            comment = comments[0]
        } else if (comments[1]) {
            comment = comments[1]
        } else if (comments[2]) {
            comment = comments[2]
        }
        return comment
    }
}



// WEBPACK FOOTER //
// ./src/browserTest.js